import React from 'react';
import PropTypes from 'prop-types';

// import hooks
import useKenwoodStickyFilters from '@/hooks/listing/Kenwood/useKenwoodStickyFilters';

const FiltersBarMobile = ({
  isGrid,
  filtersLabel,
  viewLabel,
  onOpenMobileFilters,
  onToggleView,
}) => {
  const { isSticky, wrapperRef } = useKenwoodStickyFilters();
  return (
    <section
      ref={wrapperRef}
      className={`ken-plp__filters__mobile-bar__wrapper ${
        isSticky ? ' --sticky' : ''
      }`}
    >
      <section className='ken-plp__filters__mobile-bar'>
        <section className='ken-plp__filters__mobile-bar__filter'>
          <button type='button' onClick={onOpenMobileFilters}>
            {filtersLabel}&nbsp;
            <i className='ken-icon ken-icon--filter' />
          </button>
        </section>
        <section className='ken-plp__filters__mobile-bar__view'>
          {viewLabel}
          <button
            type='button'
            className={`--single-card ${isGrid ? '' : '--active'}`}
            onClick={() => onToggleView(false)}
          />
          <button
            type='button'
            className={`--double-card ${isGrid ? '--active' : ''}`}
            onClick={() => onToggleView(true)}
          />
        </section>
      </section>
    </section>
  );
};

FiltersBarMobile.propTypes = {
  isGrid: PropTypes.bool,
  filtersLabel: PropTypes.string,
  viewLabel: PropTypes.string,
  onOpenMobileFilters: PropTypes.func,
  onToggleView: PropTypes.func,
};

FiltersBarMobile.defaultProps = {
  isGrid: false,
  filtersLabel: 'Filters',
  viewLabel: 'View',
  onOpenMobileFilters: null,
  onToggleView: null,
};

export default FiltersBarMobile;
